import { type SVGAttributes } from "react";

export function QuestionMarkIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="20.4998"
        cy="20.0001"
        r="13.3333"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M16.1069 16.808C16.1069 15.6394 16.6941 12.6667 20.6206 12.6667C22.0229 12.6667 24.7837 13.3241 24.8932 16.0411C24.8932 17.2462 24.4792 18.3223 22.7898 19.4155C22.0448 19.8975 21.2688 20.4437 20.8383 21.173C20.2382 22.1894 20.4896 22.8588 20.4891 23.3376"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <rect
        x="19.1714"
        y="25.1301"
        width="2.59066"
        height="2.59067"
        fill="currentColor"
      />
    </svg>
  );
}
